import React from 'react';
import PropTypes from 'prop-types';

import { checkbox as Checkbox } from '@breezeway/brzw-components';

import './form_control_lonely_checkbox.scss';

const FormControlLonelyCheckbox = ({ display, disabled, input: { onChange, value } }) =>
  display ? (
    <div role="presentation" onClick={() => !disabled && onChange(!value)}>
      <Checkbox.Checkbox
        selected={value}
        disabled={disabled}
        theme={Checkbox.constants.CHECKBOX_THEMES.SECONDARY}
      />
    </div>
  ) : (
    <div className="lonely-checkbox-placeholder" />
  );

FormControlLonelyCheckbox.propTypes = {
  disabled: PropTypes.bool,
  display: PropTypes.bool,
  input: PropTypes.shape({
    onChange: PropTypes.func,
    value: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  }),
};

FormControlLonelyCheckbox.defaultProps = {
  display: true,
  disabled: false,
  input: {
    value: false,
    onChange: () => {},
  },
};

export default FormControlLonelyCheckbox;
